import React from "react"
import PropTypes from "prop-types"
import { NumericFormat } from "react-number-format"

const IntegerCoefficientFormat = React.forwardRef(
  function IntegerCoefficientFormat(props, ref) {
    const { onChange, name, ...other } = props
    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        allowNegative={false}
        decimalScale={0}
        allowLeadingZeros={false}
        valueIsNumericString
        inputMode="numeric"
        onValueChange={values => {
          onChange({
            target: {
              name,
              value: values.value,
            },
          })
        }}
      />
    )
  },
)

IntegerCoefficientFormat.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
}

export default IntegerCoefficientFormat
